var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFromAssets = function SvgFromAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#from-assets_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.593 7.373A.3.3 0 0 1 2.884 7h14.232a.3.3 0 0 1 .29.373l-2.35 9.4a.3.3 0 0 1-.29.227H5.234a.3.3 0 0 1-.29-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7V3.8a.3.3 0 0 1 .3-.3h2.4a.3.3 0 0 1 .3.3v2.654c0 .301.395.415.554.159l1.778-2.845a.3.3 0 0 1 .427-.087L15.5 7"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6.5 10H10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "from-assets_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFromAssets;